import React, { type ReactNode } from 'react'

function SquareIcon(props: React.ComponentPropsWithoutRef<'svg'>): ReactNode {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" {...props}>
      <path d="M18,2a4,4,0,0,1,4,4V18a4,4,0,0,1-4,4H6a4,4,0,0,1-4-4V6A4,4,0,0,1,6,2Zm0-2H6A6,6,0,0,0,0,6V18a6,6,0,0,0,6,6H18a6,6,0,0,0,6-6V6A6,6,0,0,0,18,0Z" />
    </svg>
  )
}

export default SquareIcon
